//#region import libraries
import React, { useEffect, useState } from 'react';
//bootstrap
import { Container, Row } from 'react-bootstrap';
//custom component
import { CustomSpinner } from '_atoms';
import { FirebaseUserInfo, UserBookingHistory, DBUserInfo } from '_organisms';

// redux
import { useSelector, useDispatch } from 'react-redux'
import { selectUserStatus, getUserProfileInformation, selectUserDb, getUserReviewHistory, selectUserUUID, getUserBookings } from '../../../redux/slices/profile/user-profile'
import { getFirebaseInfo, selectUserDb as selectCouchDBUser } from '_redux/slices/main-screen/user';
//#endregion

const UserProfile = () => {
    //#region redux
    const dispatch = useDispatch();
    const uuid = useSelector(selectUserUUID);
    const dbUser = useSelector(selectUserDb);
    const status = useSelector(selectUserStatus)
    const couchDBUser = useSelector(selectCouchDBUser)
    //#endregion
    //local state
    const [toggle, setToggle] = useState('bookings');

    useEffect(() => {
        const code = dbUser ? dbUser.details.authority : couchDBUser.details.authority
        if (uuid && uuid !== "SITA" && code) {
            dispatch(getUserProfileInformation(uuid))
            dispatch(getUserReviewHistory({ uuid, code }))
            dispatch(getUserBookings(uuid))
            dispatch(getFirebaseInfo(uuid))
        }
    }, [])

    return (
        <Container>

            {status == 'loading' ? <Row className="d-flex justify-content-center align-items-center"> <CustomSpinner /></Row>
                :
                <>
                    <FirebaseUserInfo user={uuid} />
                    <DBUserInfo user={dbUser} />
                </>
            }


            {/* Booking History */}
            {toggle == 'bookings' &&
                <div className='mt-5'>
                    <UserBookingHistory user={uuid} />
                </div>
            }

        </Container>
    );
};

export default UserProfile;
